module.exports = __webpack_public_path__ + "static/shareIcon-a8fa98bf90af6b4bf902f77213811895.svg";